import React from 'react'
import styled from 'styled-components'
import IconCheck from '../Icons/IconCheck'
import IconX from '../Icons/IconX'
import { colors } from '../../healtheraComponents'
import CheckBoxButton from './CheckBoxButton'

const checkBox = (checked, disabled, tertiary, toggleMedicationHandler) => {
  if (checked) {
    return (
      <CheckBoxButton
        onClick={toggleMedicationHandler}
        icon={IconCheck}
        green
        disabled={disabled}
        tertiary={tertiary}
      />
    )
  }
  return <CheckBoxButton onClick={toggleMedicationHandler} icon={IconX} red disabled={disabled} tertiary={tertiary} />
}

const MedicationsList = ({ remedies, toggleMedicationHandler, disabled, tertiary }) => {
  return (
    <List>
      {remedies && remedies.map(({ remedy_id, course_quantity, medicine_name, approved }) => {
        return (
          <Item key={remedy_id}>
            <ItemName> {`${medicine_name}`}</ItemName>
            {checkBox(approved, disabled, tertiary, null)}
          </Item>
        )
      })}
    </List>
  )
}

export default MedicationsList

export const List = styled.ol`
  counter-reset: medicationsCounter;
  list-style-position: inside;
  margin-top: 0;
  padding: 0;
`

export const Item = styled.li`
  align-items: center;
  display: flex;
  font-weight: 600;
  padding: 19px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.GRAY_LIGHT};
  }

  &:before {
    content: counter(medicationsCounter) '.';
    counter-increment: medicationsCounter;
    flex: 0 0 25px;
  }
`

export const ItemName = styled.div`
  margin-right: auto;
`
